import dayjs from 'dayjs'
import type React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

import type { MenuTabsItem } from '@/components/NextWeekMenu/NextWeekMenuPage'
import { ProductCard } from '@/components/NextWeekMenu/ProductCard'
import type { GroupedMenu } from '@/models/menu'

import 'swiper/css'
import './content-week.scss'

export type Menu = {
  date: Date
  title: string
  items: {
    name: string
    description: string
    properties: {
      label: string
      value: string
      image: string
    }[]
    image: string
    link: string
  }[]
}

export type ContentDayProps = {
  dayData: GroupedMenu
  weekMenu: GroupedMenu[]
  index: number
}

const ContentDay: React.FC<ContentDayProps> = ({
  dayData,
  weekMenu,
  index: weekIndex,
}) => {
  const defaultSlidesPerView = 3
  const mobileSlidesPerView = 1.3
  const { date, meals } = dayData
  const _date = dayjs(date).format('dddd, MMMM D')
  const weekMeals = weekMenu.map((day) => day.meals).flat()

  return (
    <div className="week-wrapper__weekday">
      <h3>{_date}</h3>
      <div className="week-wrapper__weekday__day">
        <Swiper
          spaceBetween={0}
          slidesPerView={defaultSlidesPerView}
          freeMode={true}
          loop={true}
          breakpoints={{
            360: {
              centeredSlides: true,
              slidesPerView: mobileSlidesPerView,
              spaceBetween: 0,
            },
            800: {
              slidesPerView: defaultSlidesPerView,
              spaceBetween: 0,
            },
          }}
        >
          {meals.map((meal, index) => {
            // 3 is the number of meals per day
            const productIndex = weekIndex * 3 + index
            return (
              <SwiperSlide key={index}>
                <ProductCard
                  meal={meal}
                  mealList={weekMeals}
                  index={productIndex}
                />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </div>
  )
}

export const ContentWeek: React.FC<{ weekData: MenuTabsItem }> = ({
  weekData,
}) => {
  return (
    <div className="week-wrapper">
      {weekData?.menu.map((dayMenu, index) => (
        <ContentDay
          key={index}
          dayData={dayMenu}
          weekMenu={weekData.menu}
          index={index}
        />
      ))}
    </div>
  )
}
